import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { fetchUser } from "../../../features/userBlock/userBlockSlice";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import ViewStaffList from "./ViewStaffList";

const StaffList = () => {
  // const { users } = useSelector((state) => state.userBlock);
  const [users, setUsers] = useState([])
  const dispatch = useDispatch();
  const [viewMore, setViewMore] = useState(true)
  const [userList, setUserList] = useState([])


  useEffect(() => {
    // dispatch(fetchUser());
    api.get("users/")
      .then(response => {
        setUsers(response.data)
      }).catch(error => {
        toast("Something Went Wrong")
      })
  }, []);
  console.log("users List ", users)

  // useEffect(() => {
  //   console.log(users);
  // }, [users]);



  const handleSearch = (e) => {

    api.get(`users/?search=${e.target.value}`)
      .then(response => {
        // console.log(response.data)
        setUsers(response.data)
      }).catch(error => {
        console.log(error)
      })

  }

  const printRef = useRef(null)

  const print = useReactToPrint({
    content: () => printRef.current
  })


  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        All Staff List
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>


      {/* table  */}
      <div className="mt-3 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                {/* search */}
                <div className="flex justify-between">
                  <input
                    placeholder="Search by name"
                    type="search"
                    onChange={(e) => handleSearch(e)}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                  <input
                    placeholder="Search by branch"
                    type="search"
                    onChange={(e) => handleSearch(e)}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                  <input
                    placeholder="Search by depart"
                    type="search"
                    onChange={(e) => handleSearch(e)}
                    className="my-3 rounded-lg border border-black p-3"
                  />
                </div>
                <table ref={printRef} className="border-primary-blue min-w-full border text-center">
                  <thead className="font-Bree bg-primary-red text-lg font-bold">
                    <tr className="">
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Staff Name
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Post
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Depart
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Branch
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Contact No.
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {/* <tr className="border-primary-blue border-2 bg-white">
                      <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                        1
                      </td>
                      <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                        Shila Pokherel
                      </td>
                      <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                        manager
                      </td>
                      <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                        mngt
                      </td>
                      <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                        head office
                      </td>
                      <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                        9999999
                      </td>
                      <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                        <a
                          href=""
                          className="bg-primary-green rounded-full p-1 px-2 text-white"
                        >
                          View and edit
                        </a>
                      </td>
                    </tr> */}
                    {users.length < 1 && "No Data Found ...."}
                    {users?.slice(0, `${viewMore ? 5 : users.length}`).map((item, index) => (
                      <tr className="border-primary-blue border-2 bg-white">
                        <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                          {index + 1}
                        </td>
                        <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                          {`${item.profile.f_name} ${item.profile.l_name}`}
                          {/* {item?.profile?.f_name} */}
                        </td>
                        <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                          {item.profile.position ?? " Null "}
                        </td>
                        <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                          {/* {item.groups.name} */}
                          {item.groups[0]?.name ?? 'Null'}
                        </td>
                        <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                          {item.branch_code ?? "Null"}
                        </td>
                        <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                          {item.phone}
                        </td>
                        <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                          <button
                            onClick={() => { setUserList(item) }}
                            data-bs-toggle="modal"
                            data-bs-target="#exampleModalEdit"
                            className="bg-primary-green rounded-full p-1 px-2 text-white"
                          >
                            View
                          </button>
                          <ViewStaffList userList={userList} />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="mt-5 flex items-center justify-end gap-10">
                  <div className="bg-primary-green font-Berkshire rounded-md px-5 py-3 font-bold text-white">
                    <button onClick={print}>Print List</button>
                  </div>
                  <div className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white">
                    {viewMore ? <button onClick={() => setViewMore(false)}>View More</button> :
                      <button onClick={() => setViewMore(true)}>View Less</button>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end table */}
    </div>
  );
};

export default StaffList;
